






























































import { TargetTrackerOverview } from '@/shared/target-tracker-overview';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TargetTrackerOverviewTable extends Vue {
    @Prop({ required: true }) private targets!: Array<TargetTrackerOverview>;

    private get bankingTargetTotal(): number {
        return this.targets.filter((target) => target.bankingTarget != null)
            .reduce((total, current) => total + current.bankingTarget!, 0);
    }

    private get predictedBankingTotal(): number {
        return this.targets.filter((target) => target.predictedBanking != null)
            .reduce((total, current) => total + current.predictedBanking!, 0);
    }

    private get differenceToTargetTotal(): number {
        return this.targets.filter((target) => target.differenceToTarget != null)
            .reduce((total, current) => total + current.differenceToTarget!, 0);
    }

    private get clearedTotal(): number {
        return this.targets.filter((target) => target.cleared != null)
            .reduce((total, current) => total + current.cleared!, 0);
    }

    private get bankedTotal(): number {
        return this.targets.filter((target) => target.banked != null)
            .reduce((total, current) => total + current.banked!, 0);
    }

    private get signingBookedTotal(): number {
        return this.targets.filter((target) => target.signingBooked != null)
            .reduce((total, current) => total + current.signingBooked!, 0);
    }

    private get signingPendingTotal(): number {
        return this.targets.filter((target) => target.signingPending != null)
            .reduce((total, current) => total + current.signingPending!, 0);
    }

    private get nextMonthTotal(): number {
        return this.targets.filter((target) => target.nextMonth != null)
            .reduce((total, current) => total + current.nextMonth!, 0);
    }

    private get debtorTotal(): number {
        return this.targets.filter((target) => target.debtor != null)
            .reduce((total, current) => total + current.debtor!, 0);
    }

    private get noLongerProceedingTotal(): number {
        return this.targets.filter((target) => target.noLongerProceeding != null)
            .reduce((total, current) => total + current.noLongerProceeding!, 0);
    }

    private get consideringOptionsTotal(): number {
        return this.targets.filter((target) => target.consideringOptions != null)
            .reduce((total, current) => total + current.consideringOptions!, 0);
    }

    private legalAdvisorName(item: TargetTrackerOverview): string {
        const firstName = item.firstName == null ? '' : item.firstName.trim();
        const lastName = item.lastName == null ? '' : item.lastName.trim();

        return `${firstName} ${lastName}`.trim();
    }
}
